import React from 'react';
import PropTypes from 'prop-types';

export const SkipNavComponent = ({ skipNavAside }) => (
  <div id="nmx-skip-nav">
    <a className="nmx-nav-link" href="#main">
      Skip to main content
    </a>
    {skipNavAside && (
      <a className="nmx-nav-link" href="#aside">
        Skip to side content
      </a>
    )}
    {/* <a class="nmx-nav-link" href="#footer">Skip to footer content</a> */}
  </div>
);

SkipNavComponent.propTypes = {
  skipNavAside: PropTypes.bool.isRequired,
};

SkipNavComponent.defaultProps = {
  skipNavAside: false,
};

export default SkipNavComponent;
